module.exports = __webpack_public_path__ + "static/bartender-8b1493a99ffb42feef9534fc054b40ac.jpg";